import { BackgroundImage } from '@mantine/core';
import { AddressInput } from 'components/molecules/Address/AddressInput';
import BlobFlex from 'components/molecules/BlobFlex';
import BlobGrid from 'components/molecules/BlobGrid';
import Reviews from 'components/molecules/Landingreviews/index';
import { OFFERS } from 'constants/landingPage/offers';
import QUERY_KEYS from 'network/config/queryKeys';
import { getAllCategories } from 'network/services/goods';
import { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import BgImage from '../../assets/images/bg-images/newbackgroundimage.png';

const LandingPage = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { data: categories } = useQuery([QUERY_KEYS.CATEGORIES], () => getAllCategories(), {
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchInterval: false,
    retry: 2
  });

  const categoriesRef = useRef<any>(null);
  const scrollToExploreStores = () => {
    if (categoriesRef.current) {
      categoriesRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="w-screen overflow-hidden relative">
      {/* Address Section */}
      <div className="w-full bg-gradient-to-br from-[#0066FF] to-[#0052CC] lg:mb-12 py-16 px-8 lg:px-8">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-4">
            <h2 className="text-4xl md:text-4xl font-bold text-white mb-8">Find Stores Near You</h2>
            <p className="text-white/90 text-lg sm:text-xl md:text-lg max-w-[600px] mx-auto">
              Enter your delivery address to discover local stores and get your favorite items delivered
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-2 shadow-2xl border border-white/20">
            <AddressInput />

            <div className="mt-4 flex items-center justify-center gap-2 text-white/90 text-sm">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>We deliver to most locations in your area</span>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}

      <section ref={categoriesRef}>
        {windowWidth >= 768 ? <BlobFlex categories={categories ?? []} /> : <BlobGrid categories={categories ?? []} />}
      </section>

      <section className="w-full lg:flex items-center lg:flex-col lg:items-center lg:w-full lg:text-3xl lg:font-semibold mt-10 mb-10 lg:mt-0 lg:px-[0%]"></section>
      <div className="">
        <BackgroundImage src={BgImage} className=" overflow-hidden relative">
          <div className="absolute inset-0 bg-black bg-opacity-50 "></div>

          <section className="px-7 py-16 lg:py-24 text-white text-center font-semibold text-[20px] lg:w-full min-h-[400px] lg:min-h-[500px] grid content-center items-center relative z-[1] overflow-hidden">
            {/* <h1 className="lg:text-white text-3xl md:text-4xl lg:text-5xl lg:font-semibold lg:text-center leading-10 lg:leading-[67.2px] tracking-wide max-w-[800px] m-auto">
              Buy Now, Pay Later with Madina
            </h1> */}
            {/* <div className="grid gap-4 lg:gap-2 md:grid-cols-2 m-auto max-w-[700px] mt-6 text-base md:text-lg lg:text-xl ">
              <Link
                className="bg-white inline-flex items-center justify-center text-[#4D4D4D] py-3 font-medium px-6 rounded-xl lg:py-5"
                target="_blank"
                to="https://play.google.com/store/search?q=madina&c=apps">
                <svg
                  width="24"
                  height="23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-2"
                  viewBox="0 0 13 16">
                  <path
                    d="m6.848 7.641-6.785 7.03.001.004A1.825 1.825 0 0 0 1.834 16c.339 0 .657-.09.93-.246l.022-.013 7.637-4.301L6.848 7.64Z"
                    fill="#EA4335"></path>
                  <path
                    d="m13.713 6.444-.007-.004-3.297-1.866L6.694 7.8l3.728 3.638 3.28-1.847c.575-.303.965-.894.965-1.577 0-.677-.385-1.266-.954-1.57Z"
                    fill="#FBBC04"></path>
                  <path
                    d="M.062 1.33c-.04.146-.062.3-.062.46v12.42c0 .16.021.315.062.46l7.02-6.849L.061 1.33Z"
                    fill="#4285F4"></path>
                  <path
                    d="m6.898 8 3.512-3.427L2.78.256A1.871 1.871 0 0 0 1.834 0C.986 0 .27.563.063 1.327v.002L6.897 8Z"
                    fill="#34A853"></path>
                </svg>
                Download on Play Store
              </Link>
              <Link
                className="bg-white inline-flex items-center justify-center text-[#4D4D4D] py-3 font-medium px-6 rounded-xl mb-4 xs:mx-0 mx-4 md:mb-0 lg:py-5"
                target="_blank"
                to="https://apps.apple.com/ng/app/madina-marketplace/id6468874800">
                {renderIcon(IoLogoApple, { className: 'mr-2 text-3xl text-black' })}
                Download on App Store
              </Link>
            </div> */}
          </section>
        </BackgroundImage>
      </div>

      {/* <section className="w-full  flex flex-col items-center   relative padding-section py-14 md:py-20 xl:py-24">
        <GetAnythingDelivered exploreclick={scrollToExploreStores} />
      </section> */}

      <section className="w-full bg-primary flex flex-col items-center   relative padding-section py-10">
        <h1 className="m-auto text-white text-xl md:text-2xl font-semibold mb-8">What we offer</h1>
        <div
          className={`grid grid-cols-2 lg:grid-cols-4 justify-between  md:flex lg:grid w-full max-w-[1380px] gap-10 `}>
          {OFFERS.map(offer => (
            <Link to={offer.href} key={offer.title} className="">
              <div className="flex flex-col gap-2  items-center">
                <div className="w-[80px] h-[80px] md:w-[120px] md:h-[120px] bg-white rounded-[50%] p-4 grid place-content-center">
                  <img src={offer.img} alt="bnpl" />
                </div>
                <span className="text-md text-white font-semibold mb-3">{offer.title}</span>
              </div>
              <p className="text-center max-w-[90%] m-auto md:max-w-full  text-white ">{offer.description}</p>
            </Link>
          ))}
        </div>
      </section>
      <section className="border-none outline-none padding-section py-2 md:py-2 xl:py-2 ">
        <div className="max-width-section">
          <Reviews />
        </div>
      </section>
      {/* 
      <section className="bg-[#F04438] min-h-[200px] lg:min-h-[400px] lg:pl-20 flex px-4 lg:pr-0  md:py-0 rounded-sm  ">
        <div className=" flex-1 lg:flex-1 lg:my-auto flex items-center gap-2 ">
          <div className="h-[100%] flex flex-col gap-3 px-1 justify-center">
            <h1 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold">
              Enjoy the best prices and deals on madina
            </h1>
            <span className="text-white text-xl lg:text-2xl">Get up to 10% discount on your orders</span>
          </div>
        </div>
        <div className="lg:flex-[25%] flex relative overflow-hidden">
          <>
            <Imager src={Iphone13} width={450} height={450} className="absolute top-0 left-[20%] lg:block hidden" />
            <Imager
              src={Iphone13c}
              width={400}
              height={450}
              className="absolute bottom-[-20%] right-[0%] lg:block hidden"
            />
            <Imager src={Iphone13b} width={450} height={400} className="absolute top-0 left-[53%] lg:block hidden" />
          </>
          <Imager src={mockup} className="lg:hidden block" />
        </div>
      </section> */}
    </div>
  );
};

export default LandingPage;
